import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import API from "../services/api";

export default function Fees() {

    /* =========================================
       STATES
    ========================================= */

    const [students, setStudents] = useState([]);
 

    const [selectedStudent, setSelectedStudent] =         useState(null);

    const [searchName, setSearchName] =       useState("");

    const [className, setClassName] =        useState("");

    const [section, setSection] =        useState("");

    const [amount, setAmount] =        useState("");

    const [term, setTerm] = useState("");
    const [customTerm, setCustomTerm] = useState("");

    const [discountAmount, setDiscountAmount] =        useState(0);

    const [discountReason, setDiscountReason] =  useState("");

    const [paymentMode, setPaymentMode] =  useState("");

    const [transactionReference, setTransactionReference] =   useState("");

    const [paymentScreenshot,  setPaymentScreenshot] =   useState(null);

    const [loading, setLoading] = useState(false);
    const [paymentErrors, setPaymentErrors] = useState({});

    const [feeDetails, setFeeDetails] =  useState(null);



    const [editFee, setEditFee] = useState(false);

    const [originalFeeDetails, setOriginalFeeDetails] = useState(null);

    const [alreadyPaid, setAlreadyPaid] =
        useState(0);
    const [paymentHistory, setPaymentHistory] =
        useState([]);
    const location = useLocation();

    const queryStudentId = new URLSearchParams(
        location.search
    ).get("student");

    /* =========================================
       SEARCH STUDENTS
    ========================================= */

    const searchStudents = async () => {

        // Do not show the entire school student list
        if (
            !searchName.trim() &&
            !className &&
            !section
        ) {
            setStudents([]);
            return;
        }

        try {

            setLoading(true);

            const res = await API.get("/students");

            let filtered = res.data;

            if (searchName.trim()) {

                filtered = filtered.filter((s) =>
                    s.name
                        ?.toLowerCase()
                        .includes(searchName.toLowerCase().trim())
                );

            }

            if (className) {

                filtered = filtered.filter(
                    (s) => String(s.class) === String(className)
                );

            }

            if (section) {

                filtered = filtered.filter(
                    (s) =>
                        s.section?.toLowerCase() ===
                        section.toLowerCase()
                );

            }

            // Don't display a huge list
            setStudents(filtered.slice(0, 20));

        } catch (err) {

            console.log(err);

            alert("Unable to search students");

        } finally {

            setLoading(false);

        }
    };
 /* =========================================
   USE EFFECT
========================================= */

    useEffect(() => {

        const delaySearch = setTimeout(() => {

            searchStudents();

        }, 300);

        return () => clearTimeout(delaySearch);

    }, [

        searchName,
        className,
        section
    ]);

    useEffect(() => {

        if (!queryStudentId) return;

        const autoSelectStudent = async () => {

            try {

                const res = await API.get("/students");

                const student = res.data.find(

                    s => Number(s.id) === Number(queryStudentId)

                );

                if (student) {

                    selectStudent(student);

                }

            } catch (err) {

                console.log(err);

            }

        };

        autoSelectStudent();

    }, [queryStudentId]);


    /* =========================================
       LOAD STUDENT FEES
    ========================================= */

    const selectStudent = async (student) => {

        // Check for unsaved fee structure changes
        if (
            editFee &&
            originalFeeDetails &&
            JSON.stringify(feeDetails) !== JSON.stringify(originalFeeDetails)
        ) {

            const discard = window.confirm(
                "You have unsaved changes to the fee structure. Do you want to discard the changes and select the new student?"
            );

            if (!discard) {
                return;
            }
        }

        try {

            // =========================================
            // RESET ALL UNSAVED PAYMENT DATA
            // =========================================

            setAmount("");

            setTerm("");

            setCustomTerm("");

            setDiscountAmount(0);

            setDiscountReason("");

            setPaymentMode("");

            setTransactionReference("");

            setPaymentScreenshot(null);

            setPaymentErrors({});


            // =========================================
            // RESET FEE EDIT MODE
            // =========================================

            setEditFee(false);

            setOriginalFeeDetails(null);


            // =========================================
            // SELECT NEW STUDENT
            // =========================================

            setSelectedStudent(student);


            

            /* Get Fee Structure */

            /* Get Student Fee Structure */

            const feeRes =
                await API.get(
                    `/student-fee/${student.id}`
                );

            setFeeDetails(feeRes.data);

            // Keep a copy to detect whether the user changed anything
            setOriginalFeeDetails(
                JSON.parse(JSON.stringify(feeRes.data))
            );



            /* Get Payment History */

            const paymentRes =
                await API.get(
                    `/payments/${student.id}`
                );



            const totalPaid =
                paymentRes.data.reduce(

                    (sum, item) =>

                        sum +
                        Number(
                            item.amount_paid || 0
                        ),

                    0
                );



            setAlreadyPaid(totalPaid);

            const updatedHistory = paymentRes.data.map(payment => ({

                ...payment,

                current_balance:

                    Number(feeRes.data.total_fee || 0) -

                    totalPaid

            }));

            setPaymentHistory(updatedHistory);


        } catch (err) {

            console.log(err);

            alert(
                "Unable to load fee details"
            );
        }
    };



    /* =========================================
       TOTALS
    ========================================= */

    const totalFee =
        feeDetails
            ? Number(
                feeDetails.total_fee || 0
            )
            : 0;



    const finalFee =
        totalFee -
        Number(discountAmount || 0);



    const remainingBalance =
        finalFee -
        alreadyPaid -
        Number(amount || 0);



    /* =========================================
       PAYMENT
    ========================================= */

    const handlePayment = async () => {

        try {

            const errors = {};

            if (!term.trim()) {
                errors.term = true;
            }

            if (!amount || Number(amount) <= 0) {
                errors.amount = true;
            }

            if (
                Number(amount) >
                (finalFee - alreadyPaid)
            ) {

                alert(
                    `Payment amount cannot exceed the remaining balance of ₹${(
                        finalFee - alreadyPaid
                    ).toFixed(2)}`
                );

                return;
            }


            if (!paymentMode) {
                errors.paymentMode = true;
            }

            if (
                paymentMode !== "Cash" &&
                !transactionReference.trim()
            ) {
                errors.transactionReference = true;
            }

            if (
                Number(discountAmount) > 0 &&
                !discountReason.trim()
            ) {
                errors.discountReason = true;
            }

            setPaymentErrors(errors);

            if (Object.keys(errors).length > 0) {

                alert(
                    "Please complete all mandatory payment fields."
                );

                return;
            }

            if (!selectedStudent) {

                alert(
                    "Please select student"
                );

                return;
            }

            const formData =
                new FormData();



            formData.append(
                "student_id",
                selectedStudent.id
            );

            formData.append(
                "term",
                term
            );

            formData.append(
                "amount_paid",
                amount
            );

            formData.append(
                "discount_amount",
                discountAmount
            );

            formData.append(
                "discount_reason",
                discountReason
            );

            formData.append(
                "payment_mode",
                paymentMode
            );

            formData.append(
                "transaction_reference",
                transactionReference
            );

            formData.append(
                "updated_by",
                localStorage.getItem(
                    "username"
                )
            );

            formData.append(
                "updated_role",
                localStorage.getItem(
                    "role"
                )
            );



            if (paymentScreenshot) {

                formData.append(
                    "payment_screenshot",
                    paymentScreenshot
                );
            }



            await API.post(
                "/payments/pay",
                formData,
                {
                    headers: {
                        "Content-Type":
                            "multipart/form-data"
                    }
                }
            );



            alert(
                "Payment successful"
            );



            setAmount("");

            setTransactionReference("");

            setPaymentScreenshot(null);



            selectStudent(
                selectedStudent
            );

        } catch (err) {

            console.log(err);

            alert(
                "Payment failed"
            );
        }
    };

    const saveFeeStructure = async () => {

        try {

            if (!selectedStudent) {
                alert("Please select student");
                return;
            }

            if (!originalFeeDetails) {
                alert("Original fee structure is not available.");
                return;
            }

            const feeFields = [
                "tuition_fee",
                "activity_fee",
                "books_fee",
                "uniform_fee",
                "admission_fee",
                "sports_fee",
                "mess_fee",
                "excursion_fee",
                "transport_fee",
                "exam_fee"
            ];

            // Check whether any fee component changed
            const hasChanges = feeFields.some((field) => {

                const oldValue =
                    Number(originalFeeDetails[field] || 0);

                const newValue =
                    Number(feeDetails[field] || 0);

                return oldValue !== newValue;

            });

            // Check discount separately
            const oldDiscount =
                Number(originalFeeDetails.discount || 0);

            const newDiscount =
                Number(feeDetails.discount || 0);

            const discountChanged =
                oldDiscount !== newDiscount;

            // No changes = do not call API
            if (!hasChanges && !discountChanged) {

                alert("No changes made to fee structure.");

                return;
            }

            // Calculate ORIGINAL total directly
            const originalTotalFee =
                feeFields.reduce(
                    (total, field) =>
                        total +
                        Number(originalFeeDetails[field] || 0),
                    0
                );

            // Calculate NEW total directly
            const newTotalFee =
                feeFields.reduce(
                    (total, field) =>
                        total +
                        Number(feeDetails[field] || 0),
                    0
                );

            const totalPaid =
                Number(alreadyPaid || 0);

            // Fully paid means paid amount >= original total
            const isFullyPaid =
                totalPaid >= originalTotalFee;

            // Fully paid + overall decrease = BLOCK
            if (
                isFullyPaid &&
                newTotalFee < originalTotalFee
            ) {

                alert(
                    `This student's fees are fully paid.\n\n` +
                    `Original total fee: ₹${originalTotalFee.toFixed(2)}\n` +
                    `New total fee: ₹${newTotalFee.toFixed(2)}\n\n` +
                    `You cannot decrease the overall fee after full payment.`
                );

                return;
            }

            // Save
            await API.put(
                `/student-fee/${selectedStudent.id}`,
                {
                    tuition_fee: feeDetails.tuition_fee,
                    activity_fee: feeDetails.activity_fee,
                    books_fee: feeDetails.books_fee,
                    uniform_fee: feeDetails.uniform_fee,

                    admission_fee: feeDetails.admission_fee,
                    sports_fee: feeDetails.sports_fee,
                    mess_fee: feeDetails.mess_fee,
                    excursion_fee: feeDetails.excursion_fee,

                    transport_fee: feeDetails.transport_fee,
                    exam_fee: feeDetails.exam_fee,

                    discount: feeDetails.discount || 0,

                    updated_by:
                        localStorage.getItem("username"),

                    updated_role:
                        localStorage.getItem("role")
                }
            );

            alert("Fee structure updated successfully");

            setEditFee(false);

            setOriginalFeeDetails(null);

            // Reload saved fee structure
            try {

                const feeRes = await API.get(
                    `/student-fee/${selectedStudent.id}`
                );

                setFeeDetails(feeRes.data);

                setOriginalFeeDetails(
                    JSON.parse(
                        JSON.stringify(feeRes.data)
                    )
                );

            } catch (err) {

                console.log(err);

            }

        } catch (err) {

            console.log(err);

            alert("Unable to update fee structure");

        }

    };

     
       

    return (

        <div className="p-6 bg-gray-100 min-h-screen">

            {/* =====================================
           HEADER
        ===================================== */}

            <div className="mb-6">

                <h1 className="text-3xl font-bold text-gray-800">

                    Fee Collection

                </h1>

                <p className="text-gray-500 mt-1">

                    Search a student, view fee history and collect payments

                </p>

            </div>



            {/* =====================================
           MAIN LAYOUT
        ===================================== */}

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">

                {/* =====================================
               LEFT SIDE - SEARCH + STUDENTS
            ===================================== */}

                <div className="lg:col-span-1">

                    <div className="bg-white rounded-2xl shadow p-5 sticky top-5">

                        <h2 className="text-xl font-bold mb-4">

                            Search Students

                        </h2>



                        {/* Search Fields */}

                        <div className="space-y-4">

                            <input
                                type="text"
                                placeholder="Student Name"
                                value={searchName}
                                onChange={(e) =>
                                    setSearchName(
                                        e.target.value
                                    )
                                }
                                className="border p-3 rounded-xl w-full"
                            />



                            <select
                                value={className}
                                onChange={(e) =>
                                    setClassName(
                                        e.target.value
                                    )
                                }
                                className="border p-3 rounded-xl w-full"
                            >

                                <option value="">
                                    All Classes
                                </option>

                                <option>PP1</option>
                                <option>PP2</option>
                                <option>LKG</option>
                                <option>UKG</option>

                                {
                                    [...Array(10)].map((_, i) => (

                                        <option key={i}>
                                            {i + 1}
                                        </option>
                                    ))
                                }

                            </select>



                            <select
                                value={section}
                                onChange={(e) =>
                                    setSection(
                                        e.target.value
                                    )
                                }
                                className="border p-3 rounded-xl w-full"
                            >

                                <option value="">
                                    All Sections
                                </option>

                                <option>A</option>
                                <option>B</option>
                                <option>C</option>

                            </select>



                           

                        </div>



                        {/* Student Results */}

                        <div className="mt-6 max-h-[600px] overflow-y-auto space-y-3">

                            {
                                students.length === 0 ? (

                                    <div className="text-gray-400 text-center py-10">

                                        No students found

                                    </div>

                                ) : (

                                    students.map((student) => {

                                        const pending =
                                            Number(student.balance || 0);

                                        return (

                                            <div
                                                key={student.id}
                                                className={`border-2 rounded-xl p-4 transition hover:shadow-lg

                                                 ${selectedStudent?.id === student.id
                                                        ? "border-blue-600 bg-blue-50"
                                                        : "border-gray-200 bg-white"
                                                    }`}
                                            >

                                                <div className="flex justify-between items-center">

                                                    <div>

                                                        <h2 className="font-bold text-lg">

                                                            {student.name}

                                                        </h2>

                                                        <p className="text-gray-500 text-sm">

                                                            {student.class}
                                                            -
                                                            {student.section}

                                                        </p>

                                                    </div>



                                                    <div>

                                                        {
                                                            pending > 30000 ? (

                                                                <span className="bg-red-100 text-red-700 text-xs px-3 py-1 rounded-full">

                                                                    High Due

                                                                </span>

                                                            ) : pending > 0 ? (

                                                                <span className="bg-yellow-100 text-yellow-700 text-xs px-3 py-1 rounded-full">

                                                                    Pending

                                                                </span>

                                                            ) : (

                                                                <span className="bg-green-100 text-green-700 text-xs px-3 py-1 rounded-full">

                                                                    Paid

                                                                </span>
                                                            )
                                                        }

                                                    </div>

                                                  

                                                </div>

                                                <button
                                                    onClick={() => selectStudent(student)}
                                                    className="mt-4 w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded-xl font-semibold"
                                                >
                                                    View Fee Details
                                                </button>

                                            </div>
                                        );
                                    })
                                )
                            }

                        </div>

                    </div>

                </div>



                {/* =====================================
               RIGHT SIDE - PAYMENT PANEL
            ===================================== */}

                <div className="lg:col-span-2">

                    {
                        !selectedStudent ? (

                            <div className="bg-white rounded-2xl shadow p-20 text-center text-gray-400">

                                Select a student to collect fees

                            </div>

                        ) : (

                            <div className="bg-white rounded-2xl shadow p-6 sticky top-5">

                                {/* Student Header */}

                                <div className="flex justify-between items-center mb-6">

                                    <div>

                                        <h2 className="text-3xl font-bold">

                                            {
                                                selectedStudent.name
                                            }

                                        </h2>

                                        <p className="text-gray-500 mt-1">

                                            Class:
                                            {
                                                selectedStudent.class
                                            }
                                            -
                                            {
                                                selectedStudent.section
                                            }

                                        </p>

                                    </div>

                                </div>



                                {/* Fee Cards */}

                                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">

                                    <div className="bg-blue-50 p-4 rounded-xl">

                                        <p className="text-sm text-gray-500">

                                            Total Fee

                                        </p>

                                        <h2 className="text-2xl font-bold">

                                            ₹{totalFee}

                                        </h2>

                                    </div>



                                    <div className="bg-green-50 p-4 rounded-xl">

                                        <p className="text-sm text-gray-500">

                                            Paid

                                        </p>

                                        <h2 className="text-2xl font-bold">

                                            ₹{alreadyPaid}

                                        </h2>

                                    </div>



                                    <div className="bg-yellow-50 p-4 rounded-xl">

                                        <p className="text-sm text-gray-500">

                                            Discount

                                        </p>

                                        <h2 className="text-2xl font-bold">

                                            ₹{discountAmount}

                                        </h2>

                                    </div>



                                    <div className="bg-red-50 p-4 rounded-xl">

                                        <p className="text-sm text-gray-500">

                                            Balance

                                        </p>

                                        <h2 className="text-2xl font-bold">

                                            ₹{remainingBalance}

                                        </h2>

                                    </div>

                                </div>

                                    <button
                                        onClick={() => {

                                            if (editFee) {

                                                // Cancel editing and restore original values
                                                setFeeDetails(
                                                    JSON.parse(
                                                        JSON.stringify(originalFeeDetails)
                                                    )
                                                );

                                                setEditFee(false);

                                            } else {

                                                // Start editing with current values as original reference
                                                setOriginalFeeDetails(
                                                    JSON.parse(
                                                        JSON.stringify(feeDetails)
                                                    )
                                                );

                                                setEditFee(true);
                                            }

                                        }}
                                        className="bg-blue-600 text-white px-4 py-2 rounded"
                                    >
                                        {editFee ? "Cancel" : "Edit Fee Structure"}
                                    </button>


                                {/* Fee Breakdown */}

                                <div className="bg-gray-50 rounded-2xl p-5 mb-6">

                                    <h3 className="text-xl font-bold mb-4">

                                        Fee Breakdown

                                    </h3>

                                        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">

                                            {[
                                                ["Tuition Fee", "tuition_fee"],
                                                ["Activity Fee", "activity_fee"],
                                                ["Books Fee", "books_fee"],
                                                ["Uniform Fee", "uniform_fee"],
                                                ["Sports Fee", "sports_fee"],
                                                ["Transport Fee", "transport_fee"],
                                                ["Admission Fee", "admission_fee"],
                                                ["Exam Fee", "exam_fee"]
                                            ].map(([label, field]) => (

                                                <div
                                                    key={field}
                                                    className="bg-white rounded-xl p-3 border"
                                                >

                                                    <p className="text-xs text-gray-500 mb-2">

                                                        {label}

                                                    </p>

                                                    {
                                                        editFee ? (

                                                            <input

                                                                type="number"

                                                                value={feeDetails?.[field] || 0}

                                                                onChange={(e) =>

                                                                    setFeeDetails({

                                                                        ...feeDetails,

                                                                        [field]: e.target.value

                                                                    })

                                                                }

                                                                className="border rounded-lg p-2 w-full"

                                                            />

                                                        ) : (

                                                            <p className="font-bold">

                                                                ₹{feeDetails?.[field] || 0}

                                                            </p>

                                                        )

                                                    }

                                                </div>

                                            ))}

                                        </div>


                                    </div>

                                

                {
                    editFee && (

                        <button

                            onClick={saveFeeStructure}

                            className="bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-xl mb-6"

                        >

                            Save Fee Structure

                        </button>

                    )
                }


{/* =====================================
   RECENT PAYMENT HISTORY
===================================== */}

                                    {/* =====================================
   RECENT PAYMENT HISTORY
===================================== */}

                                    <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl p-5 mb-6 border border-blue-100">

                                        <div className="flex justify-between items-center mb-5">

                                            <div>

                                                <h3 className="text-2xl font-bold text-gray-800">

                                                    Recent Payments

                                                </h3>

                                                <p className="text-gray-500 text-sm mt-1">

                                                    Latest fee collections

                                                </p>

                                            </div>



                                            <div className="bg-blue-600 text-white px-4 py-2 rounded-full text-sm font-semibold">

                                                {paymentHistory.length} Payments

                                            </div>

                                        </div>



                                        {
                                            paymentHistory.length === 0 ? (

                                                <div className="bg-white rounded-xl p-8 text-center text-gray-400">

                                                    No previous payments found

                                                </div>

                                            ) : (

                                                <div className="space-y-4 max-h-[320px] overflow-y-auto pr-2">

                                                    {
                                                        paymentHistory.map((payment) => (

                                                            <div
                                                                key={payment.id}
                                                                className="bg-white rounded-2xl shadow-sm border border-gray-100 p-5 hover:shadow-md transition"
                                                            >

                                                                <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-4">

                                                                    {/* LEFT */}

                                                                    <div>

                                                                        <div className="flex items-center gap-3">

                                                                            <div className="w-12 h-12 rounded-full bg-green-100 flex items-center justify-center text-green-700 font-bold text-lg">

                                                                                ₹

                                                                            </div>



                                                                            <div>

                                                                                <h4 className="text-xl font-bold text-gray-800">

                                                                                    ₹{
                                                                                        payment.amount_paid
                                                                                    }

                                                                                </h4>

                                                                                <p className="text-sm text-gray-500">

                                                                                    {
                                                                                        selectedStudent?.name
                                                                                    }

                                                                                </p>

                                                                            </div>

                                                                        </div>

                                                                    </div>



                                                                    {/* CENTER */}

                                                                    <div className="grid grid-cols-2 md:grid-cols-3 gap-4 flex-1">

                                                                        <div>

                                                                            <p className="text-xs text-gray-400 uppercase">

                                                                                Term

                                                                            </p>

                                                                            <p className="font-semibold">

                                                                                {
                                                                                    payment.term
                                                                                }

                                                                            </p>

                                                                        </div>



                                                                        <div>

                                                                            <p className="text-xs text-gray-400 uppercase">

                                                                                Balance

                                                                            </p>

                                                                            <p className="font-semibold text-red-600">

                                                                                ₹{
                                                                                    payment.current_balance
                                                                                }

                                                                            </p>

                                                                        </div>



                                                                        <div>

                                                                            <p className="text-xs text-gray-400 uppercase">

                                                                                Mode

                                                                            </p>

                                                                            <p className="font-semibold">

                                                                                {
                                                                                    payment.payment_mode
                                                                                }

                                                                            </p>

                                                                        </div>

                                                                    </div>



                                                                    {/* RIGHT */}

                                                                    <div className="text-right">

                                                                        <div className="bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-sm font-semibold inline-block">

                                                                            {
                                                                                new Date(
                                                                                    payment.payment_date
                                                                                ).toLocaleDateString()
                                                                            }

                                                                        </div>



                                                                        <p className="text-xs text-gray-400 mt-2">

                                                                            Ref:
                                                                            {
                                                                                payment.transaction_reference || "-"
                                                                            }

                                                                        </p>

                                                                    </div>

                                                                </div>

                                                            </div>
                                                        ))
                                                    }

                                                </div>
                                            )
                                        }

                                    </div>

                                {/* Payment Form */}

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

                                        <div>

                                            <label className="block mb-2 font-semibold">
                                                Term <span className="text-red-600">*</span>
                                            </label>

                                            <select
                                                value={term}
                                                onChange={(e) => {
                                                    setTerm(e.target.value);

                                                    setPaymentErrors(prev => ({
                                                        ...prev,
                                                        term: false
                                                    }));
                                                }}
                                                className={`border p-3 rounded-xl w-full ${paymentErrors.term
                                                        ? "border-red-500 bg-red-50"
                                                        : "border-gray-300"
                                                    }`}
                                            >

                                                <option value="">
                                                    Select Term
                                                </option>

                                                <option value="Term1">
                                                    Term 1
                                                </option>

                                                <option value="Term2">
                                                    Term 2
                                                </option>

                                                <option value="Term3">
                                                    Term 3
                                                </option>

                                                <option value="Other">
                                                    Other / Custom
                                                </option>

                                            </select>

                                            {paymentErrors.term && (
                                                <p className="text-red-600 text-sm mt-1">
                                                    Term is required
                                                </p>
                                            )}

                                            {term === "Other" && (

                                                <input
                                                    type="text"
                                                    placeholder="Enter term / installment name"
                                                    value={customTerm}
                                                    onChange={(e) => {
                                                        setCustomTerm(e.target.value);

                                                        setPaymentErrors(prev => ({
                                                            ...prev,
                                                            term: false
                                                        }));
                                                    }}
                                                    className={`border p-3 rounded-xl w-full mt-3 ${paymentErrors.term
                                                            ? "border-red-500 bg-red-50"
                                                            : "border-gray-300"
                                                        }`}
                                                />

                                            )}

                                        </div>



                                        <div>

                                            <label className="block mb-2 font-semibold">
                                                Amount Paid <span className="text-red-600">*</span>
                                            </label>

                                            <input
                                                type="number"
                                                min="1"
                                                placeholder="Enter amount"
                                                value={amount}
                                                onChange={(e) => {

                                                    setAmount(e.target.value);

                                                    setPaymentErrors(prev => ({
                                                        ...prev,
                                                        amount: false
                                                    }));

                                                }}
                                                className={`border p-3 rounded-xl w-full ${paymentErrors.amount
                                                        ? "border-red-500 bg-red-50"
                                                        : "border-gray-300"
                                                    }`}
                                            />

                                            {paymentErrors.amount && (
                                                <p className="text-red-600 text-sm mt-1">
                                                    Amount Paid is required
                                                </p>
                                            )}

                                        </div>



                                        <div className="bg-green-50 border border-green-200 rounded-2xl p-4">

                                            <label className="block mb-2 font-bold text-green-800">
                                                Scholarship / Discount
                                            </label>

                                            <input
                                                type="number"
                                                placeholder="₹ Enter concession amount"
                                                value={discountAmount}
                                                onChange={(e) =>
                                                    setDiscountAmount(e.target.value)
                                                }
                                                className="border rounded-xl p-3 w-full bg-white"
                                            />

                                            <p className="text-xs text-green-700 mt-2">
                                                Applicable for scholarship, sibling discount or fee concession
                                            </p>

                                        </div>



                                        <div>

                                            <label className="block mb-2 font-semibold">

                                                Discount Reason

                                                {Number(discountAmount) > 0 && (
                                                    <span className="text-red-600"> *</span>
                                                )}

                                            </label>

                                            <input
                                                type="text"
                                                placeholder="Reason for discount / concession"
                                                value={discountReason}
                                                onChange={(e) => {

                                                    setDiscountReason(e.target.value);

                                                    setPaymentErrors(prev => ({
                                                        ...prev,
                                                        discountReason: false
                                                    }));

                                                }}
                                                className={`border p-3 rounded-xl w-full ${paymentErrors.discountReason
                                                        ? "border-red-500 bg-red-50"
                                                        : "border-gray-300"
                                                    }`}
                                            />

                                            {paymentErrors.discountReason && (
                                                <p className="text-red-600 text-sm mt-1">
                                                    Discount reason is required
                                                </p>
                                            )}

                                        </div>



                                        <div>

                                            <label className="block mb-2 font-semibold">
                                                Payment Mode <span className="text-red-600">*</span>
                                            </label>

                                            <select
                                                value={paymentMode}
                                                onChange={(e) => {

                                                    setPaymentMode(e.target.value);

                                                    setPaymentErrors(prev => ({
                                                        ...prev,
                                                        paymentMode: false
                                                    }));

                                                }}
                                                className={`border p-3 rounded-xl w-full ${paymentErrors.paymentMode
                                                        ? "border-red-500 bg-red-50"
                                                        : "border-gray-300"
                                                    }`}
                                            >

                                                <option value="">
                                                    Select Payment Mode
                                                </option>

                                                <option value="Cash">
                                                    Cash
                                                </option>

                                                <option value="PhonePe">
                                                    PhonePe
                                                </option>

                                                <option value="Google Pay">
                                                    Google Pay
                                                </option>

                                                <option value="UPI">
                                                    UPI
                                                </option>

                                                <option value="Bank Transfer">
                                                    Bank Transfer
                                                </option>

                                            </select>

                                            {paymentErrors.paymentMode && (
                                                <p className="text-red-600 text-sm mt-1">
                                                    Payment mode is required
                                                </p>
                                            )}

                                        </div>



                                        <div>

                                            <label className="block mb-2 font-semibold">

                                                Transaction Reference

                                                {paymentMode !== "Cash" && (
                                                    <span className="text-red-600"> *</span>
                                                )}

                                            </label>

                                            <input
                                                type="text"
                                                placeholder={
                                                    paymentMode === "Cash"
                                                        ? "Not required for Cash"
                                                        : "Enter transaction / UTR reference"
                                                }
                                                value={transactionReference}
                                                onChange={(e) => {

                                                    setTransactionReference(e.target.value);

                                                    setPaymentErrors(prev => ({
                                                        ...prev,
                                                        transactionReference: false
                                                    }));

                                                }}
                                                className={`border p-3 rounded-xl w-full ${paymentErrors.transactionReference
                                                        ? "border-red-500 bg-red-50"
                                                        : "border-gray-300"
                                                    }`}
                                            />

                                            {paymentErrors.transactionReference && (
                                                <p className="text-red-600 text-sm mt-1">
                                                    Transaction reference is required
                                                </p>
                                            )}

                                        </div>



                                    <input
                                        type="file"
                                        accept="image/*"
                                        onChange={(e) =>
                                            setPaymentScreenshot(
                                                e.target.files[0]
                                            )
                                        }
                                        className="border p-3 rounded-xl"
                                    />

                                </div>



                                <button
                                    onClick={handlePayment}
                                    className="bg-green-700 hover:bg-green-800 text-white px-8 py-3 rounded-xl mt-6 w-full"
                                >

                                    Collect Payment

                                </button>

                            </div>
                        )
                    }

                </div>

            </div>

        </div>
    );
}